<template>
  <v-card flat class="monitors-bar">
    <v-app-bar elevation="1" class="px-11">
      <v-app-bar-title class="text-primary text-h6 font-weight-bold">
        {{ label }}
      </v-app-bar-title>
      <v-row>
        <v-col>
          <SiteAutocomplete
            class="mt-6 mr-5"
            :items="sitesForDevices"
            v-model="selectedSite"
            @update:modelValue="
              (value) => setDefaultSiteFromDevicesDomain(value)
            "
          />
        </v-col>
      </v-row>
      <v-spacer />
    </v-app-bar>
  </v-card>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue';
import API from '@/Core.Service.Domain/Devices/Devices.Common/API/index.ts';
import { ISite } from '@/Core.Service.Domain/Sites/Sites.Common/types/site.ts';

import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import SiteAutocomplete from '@/Core.UI.Domain/Components/SiteAutocomplete.vue';

const sitesForDevices = ref<ISite[]>([]);
const selectedSite = ref<ISite | null>(null);
const label = 'Device Provisioning';

const store = useStore();
const router = useRouter();
const setDefaultSiteFromDevicesDomain = async (site: ISite | null = null) => {
  selectedSite.value = site || defaultSite.value;
  store.commit('session/setDefaultSite', selectedSite.value);
  store.commit(
    'DevicesStore/SetSelectedSiteId',
    selectedSite.value?.siteId || selectedSite.value?.id
  );
  router.push({
    name: 'DeviceProperties',
    params: { siteId: selectedSite.value?.siteId || selectedSite.value?.id },
  });
};

const defaultSite = computed(() => store.getters['session/defaultSite']);

onMounted(async () => {
  store.commit('DevicesStore/SetIsPortfolioLoading', true);
  sitesForDevices.value = await API.getSitesForDevices();
  setDefaultSiteFromDevicesDomain();
  store.commit('DevicesStore/SetIsPortfolioLoading', false);
});
</script>
<style lang="scss" scoped>
.monitors-bar {
  z-index: 1;
}

.v-input {
  max-width: 700px !important;
}

:deep(.v-field__input) {
  color: $primary !important;
}

:deep(.bg-white) {
  color: $primary !important;
}
</style>
